// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__vDnDD","content":"Home_content__36nuS"};